import React, { Suspense, useEffect, useState } from 'react'
import { Navigate, Route, Routes,  useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";
import { styled } from "@mui/material"
import { AppFooter } from "./index"
// routes config
import routes from '../routes'

const ContentMain = styled("div", {
    shouldForwardProp: (prop) => prop !== "alert",
})(({ theme, alert }) => ({
    flexGrow: 1,
    padding: "0px 24px",
    position: "relative",
    background: theme.palette.common.white,
    marginTop: alert ? "108px" : "64px",
    height: alert ? "calc(100vh - 144px)" : "calc(100vh - 100px)",
    overflowY: "auto",
    marginRight: "16px",
    borderRadius: "16px",
    transition: theme.transitions.create(["margin-top", "height"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
}));

const AppContent = () => {

    const isAlert = useSelector((state) => state.setAlert);
    // const navigate = new useNavigate();
    // const user = localStorage.getItem("token");
    // if (!user)
    //     navigate("/");

    const location = useLocation();

    // const [progress, setProgress] = useState(false)
    const [prevLoc, setPrevLoc] = useState("")

    useEffect(() => {
        setPrevLoc(location.pathname)
        // setProgress(true)
        if (location.pathname === prevLoc) {
            setPrevLoc('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    // useEffect(() => {
    //     setProgress(false)
    // }, [prevLoc])

    return (
        <>
            <ContentMain alert={isAlert} component="main" className="main-page">
                 {/* <Suspense fallback="Loading..."> 11/04/2024*/} 
                <Suspense>
                    <Routes>
                        {routes.map((route, idx) => {
                            return (
                                route.element && (
                                    <Route
                                        key={idx}
                                        path={route.path}
                                        exact={route.exact}
                                        name={route.name}
                                        element={<route.element />}
                                    />
                                )
                            )
                        })}
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </Suspense>
            </ContentMain>
            <AppFooter />
        </>
    )
}

export default AppContent